module.exports = __webpack_public_path__ + "static/media/contacts.0b897ac6.png";